import { Typography } from '@mui/material'
import NoRouteIcon from './NoRouteIcon'

const NoRoute = () => {
  return (
    <div className="no_route_block">
      <NoRouteIcon className="no_route_icon" />
      <Typography className="no_route_title">
        Оберіть транспорт та маршрут, щоб дізнатися більше
      </Typography>
    </div>
  )
}

export default NoRoute
